import React, { useEffect, useState, createContext, useContext } from 'react';
import db from '../services/database';
interface DatabaseContextProps {
  isLoaded: boolean;
  db: typeof db;
}
const DatabaseContext = createContext<DatabaseContextProps | undefined>(undefined);
export const DatabaseProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const initDb = async () => {
      try {
        await db.initializeDatabase();
        setIsLoaded(true);
      } catch (error) {
        console.error('Failed to initialize database:', error);
      }
    };
    initDb();
  }, []);
  return <DatabaseContext.Provider value={{
    isLoaded,
    db
  }} data-id="element-204">
      {children}
    </DatabaseContext.Provider>;
};
export const useDatabase = () => {
  const context = useContext(DatabaseContext);
  if (context === undefined) {
    throw new Error('useDatabase must be used within a DatabaseProvider');
  }
  return context;
};